"use client";
import { useEffect } from "react";
import { useAuthError } from "@/context/AuthErrorContext";
import { setupAuthErrorHandler } from "@/services/api";

/**
 * AuthErrorInitializer
 * Initializes the auth error handler so that 401 errors from the API
 * will trigger the UnauthorizedPage display
 */
export function AuthErrorInitializer() {
    const { setAuthError } = useAuthError();

    useEffect(() => {
        // Set up the handler function
        const errorHandler = (message: string) => {
            setAuthError({
                message,
                timestamp: Date.now(),
            });
        };

        setupAuthErrorHandler(errorHandler);

        // Cleanup
        return () => {
            setupAuthErrorHandler(() => { });
        };
    }, [setAuthError]);

    return null;
}
